import { render, staticRenderFns } from "./BookingEmailHeader.vue?vue&type=template&id=29563f07"
import script from "./BookingEmailHeader.vue?vue&type=script&lang=js"
export * from "./BookingEmailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports